import moment from 'moment';

export const hasActiveTrial = (trialEnd) => {
  /* Determine if the user currently has an active trial based on their trial
     end date. */
  return moment() < moment(trialEnd);
};
